import { Link } from "react-router-dom";

interface Crumb {
  label: string;
  to?: string;
}

export default function Breadcrumb({ items }: { items: Crumb[] }) {
  return (
    <nav aria-label="面包屑" className="flex flex-wrap items-center gap-1 text-xs text-foreground-500">
      {items.map((item, i) => (
        <span key={`${item.label}-${i}`} className="flex items-center gap-1">
          {item.to ? (
            <Link to={item.to} className="transition-colors hover:text-primary-700">
              {item.label}
            </Link>
          ) : (
            <span className="text-foreground-800">{item.label}</span>
          )}
          {i < items.length - 1 && <i className="ri-arrow-right-s-line text-foreground-400" />}
        </span>
      ))}
    </nav>
  );
}